import React, { Component } from 'react';
import { SORT } from './../../../constants';
import SortIndicators from './../../SortIndicators/SortIndicators.index';
import utilities from './../../../utils/utilities';
import commonActions from './../../../api/Common.actions';
import reduxStore from '../../../reduxStore';

export default function withSort(CollectionComponent) {
    class Sortable extends Component {
        constructor(props) {
            super(props);

            let sorting = {};
            props.headerItems.forEach(headerItem => {
                if (headerItem.sortable) {
                    sorting[headerItem.key] = SORT.DEFAULT
                    if (headerItem.key === this.props.defaultSort.sortBy) {
                        sorting[headerItem.key] = this.props.defaultSort.direction
                    }
                }
            });

            this.state = {
                sorting,
                pendingRequest: false
            }

            this.sort = this.sort.bind(this);
            this.loadItems = this.loadItems.bind(this);
        }

        componentDidMount() {
            this._isMounted = true;
        }

        componentWillUnmount() {
            this._isMounted = false;
        }

        /**
         * Setter for pendingRequest in state
         * @param value
         * @returns {Sortable}
         */
        setPendingRequest(value) {
            if (!this._isMounted) return;
            this.setState({ pendingRequest: value });
            return this;
        }

        loadItems(params = null) {
            let newParams = {};
            if (params) {
                newParams = params;
            }
            newParams.sorting = this.getSortState();

            if (!this.state.pendingRequest) {
                this.setPendingRequest(true);
                return this.props.loadItems(newParams).then(response => {
                    this.setPendingRequest(false);
                    return response;
                })
            }
        }

        nextSortState(sortState, item) {
            switch (sortState) {
                case SORT.DESC:
                    this.persistSortStatePreference(item, SORT.ASC);
                    return SORT.ASC;
                case SORT.ASC:
                    this.persistSortStatePreference(item, SORT.DESC);
                    return SORT.DESC;
                default:
                    this.persistSortStatePreference(item, SORT.ASC);
                    return SORT.ASC;
            }
        }

        persistSortStatePreference(item, direction) {
            if (item.persistableSort) {
                let pagesTablesSort = reduxStore.getState().user.preferences.pagesTablesSort;
                commonActions.updateUserPrefs({
                    pagesTablesSort: Object.assign({}, pagesTablesSort, {
                        [item.persistableSort]: {
                            'sortBy':    item.key,
                            'direction': direction
                        }
                    })
                });
            }
        }

        /**
         * Retrieves sort state
         * @returns {{sortBy: *, direction: *}}
         */
        getSortState() {
            let sorting = null;
            for (let key in this.state.sorting) {
                if (this.state.sorting[key] !== SORT.DEFAULT) {
                    sorting = {
                        sortBy: key,
                        direction: this.state.sorting[key]
                    }
                }
            }
            return { ...sorting }
        }

        sort(item) {
            if (!this.state.pendingRequest) {
                let sorting = this.state.sorting;
                let defaultSort = {};
                this.props.headerItems.forEach((item) => {
                    if (item.sortable) defaultSort[item.key] = SORT.DEFAULT
                });
                this.setState({
                    sorting: {
                        ...defaultSort,
                        [item.key]: this.nextSortState(sorting[item.key], item)
                    }
                }, () => {
                    this.loadItems({reset: true, pagination: { pageNumber: 0 }});
                })
            }
        }

        render() {
            const headerItems = this.props.headerItems.map(item => {
                if (item.sortable) {
                    const label = item.label;
                    item.content = <span className="sortable" onClick={() => this.sort(item)}>
                            {label} <SortIndicators direction={this.state.sorting[item.key]}/>
                        </span>
                }
                return item;
            });
            return <CollectionComponent {...this.props}
                                        headerItems={headerItems}
                                        loadItems={this.loadItems} />
        }
    }

    Sortable.displayName = `Sortable(${utilities.getDisplayName(CollectionComponent)})`;
    return Sortable;

}



// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/hoc/Sortable.jsx